import React, { useState, useEffect } from "react";

import RadioButton from "../../../../common/RadioButton";
import InputField from "../../../../common/InputField";

import { LinkButton, SecondaryButton } from "../../../../common/Buttons";
import { Typography, Box, Grid, Divider } from "@mui/material";
import { Formik, Form } from "formik";
import {
  downloadPdfOrganDonationApi,
  getOrganDonationData,
  postOrganDonationData,
} from "../../../../services/documentServices";
import download from "../../../../assets/images/download.png";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Circles } from "react-loader-spinner";
import { Spinner } from "phosphor-react";

const OrganDonationOverview = ({ next }) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const permissionList = [
    {
      id: 1,
      description: `YES, I give my permission for organs and tissues to be removed from my body after my death has been medically determined.`,
      check: false,
    },
    {
      id: 2,
      description: `YES, I allow this, with the exception of the following organs/tissues:`,
      check: false,
    },
    {
      id: 3,
      description: `YES, I allow this, but only for the following organs/tissues:`,
      check: false,
    },
    {
      id: 4,
      description: `NO, I object to the removal of organs or tissues.`,
      check: false,
    },
    {
      id: 5,
      description: `The following person should then decide on yes or NO:`,
      check: true,
    },
  ];
  const [permissionState, setPermissionState] = useState(permissionList);
  const [data, setData] = useState(null);
  const [initialValues, setInitialValues] = useState({
    declarationType: "",
    declaration_name: "",
    declaration_date: "",
    declaration_street: "",
    declaration_postCode: "",
    declaration_phone: "",
    name: "",
    dateOfBirth: "",
    address: "",
  });
  const handleCheckbox = (id) => {
    const updateList = permissionState.map((ele) => {
      if (ele.id == id) return { ...ele, check: true };
      else return { ...ele, check: false };
    });
    setPermissionState(updateList);
  };
  async function fetchData() {
    setIsLoading(true);
    try {
      const result = await getOrganDonationData(id);
      if (result?.success && result?.payLoad) {
        setData(result.payLoad);
        if (result?.payLoad?.declarationType === 5) {
          if (result?.payLoad?.organDonationAuthorizePerson) {
            setInitialValues({
              declarationType: result?.payLoad?.declarationType,
              declaration_name:
                result?.payLoad?.organDonationAuthorizePerson?.name || "",
              declaration_date:
                result?.payLoad?.organDonationAuthorizePerson?.dateOfBirth?.slice(
                  0,
                  10
                ) || "",
              declaration_street:
                result?.payLoad?.organDonationAuthorizePerson?.street || "",
              declaration_postCode:
                result?.payLoad?.organDonationAuthorizePerson?.postCode || "",
              declaration_phone:
                result?.payLoad?.organDonationAuthorizePerson?.phone || "",
              ...(result?.payLoad?.organDonationPersonDetail && {
                ...result?.payLoad?.organDonationPersonDetail,
                dateOfBirth:
                  result?.payLoad?.organDonationPersonDetail?.dateOfBirth?.slice(
                    0,
                    10
                  ) || "",
              }),
            });
          }
        } else {
          setInitialValues({
            declarationType: result?.payLoad?.declarationType || "",
            ...(result?.payLoad?.organDonationPersonDetail && {
              ...result?.payLoad?.organDonationPersonDetail,
              dateOfBirth:
                result?.payLoad?.organDonationPersonDetail?.dateOfBirth?.slice(
                  0,
                  10
                ) || "",
            }),
            declaration_name: result?.payLoad?.declarationDescription || "",
          });
        }
        if (result?.payLoad?.declarationType > 0)
          handleCheckbox(result.payLoad.declarationType);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    fetchData();
  }, []);
  const handleSubmit = async (values) => {
    const payload = {
      ...data,
      organDonationPersonDetail: {
        ...values,
      },
    };
    const result = await postOrganDonationData(payload, id);
    if (result?.success) {
      // toast.success(
      //   t(
      //     result?.message
      //       .toLowerCase()
      //       .replaceAll(" ", "-")
      //       .replaceAll("/", "-")
      //       .replaceAll(",", "")
      //       .replaceAll("'", "")
      //   )
      // );
      next();
    }
  };
  async function downloadPdf() {
    setIsFetching(true);
    const result = await downloadPdfOrganDonationApi(id, t);
    setIsFetching(false);
  }
  return (
    <>
      {isLoading ? (
        <Box component="div" className="loader-container">
          <Circles color="#dfc8db" height={80} width={80} />
        </Box>
      ) : (
        <Box
          component="div"
          className="organ-donation-container summary-table documents-card-height"
        >
          <Typography variant="h4" fontWeight="bold" ml={7}>
            {t("doc-tab-4")}
          </Typography>
          <div className="download">
            <div>
              {isFetching ? (
                <Spinner />
              ) : (
                <img
                  src={download}
                  height={16}
                  width={16}
                  onClick={downloadPdf}
                />
              )}
              <Typography fontWeight={"bold"}>{t("download")}</Typography>
            </div>
          </div>
          <Typography variant="p" fontSize="12px" ml={7}>
            {t("sidebar-3-text-3")}
          </Typography>
          <Box component="div" className="sub-container">
            <Box component="div" className="section-1">
              <Typography variant="h5" className="typography-1">
                {t("organ-donation-dec")}
              </Typography>
              <Box component="div" className="sub-section-1">
                <Typography variant="p">
                  {t("od-overview-text")} <br /> {t("od-overview-text-1")}
                </Typography>
              </Box>

              <Box component="div" className="sub-section-2">
                {permissionState.map((elem, index) => {
                  return (
                    <Box component="div" className="block-1">
                      <RadioButton
                        className="svg-block-lg"
                        theme="box"
                        checked={elem.check ? true : false}
                      />
                      <Typography variant="p" marginLeft="1rem">
                        {t(`description${index}`) || ""}
                      </Typography>
                    </Box>
                  );
                })}
              </Box>
              <Formik
                initialValues={initialValues}
                enableReinitialize
                onSubmit={(values) => handleSubmit(values)}
              >
                {(formik) => (
                  <Form>
                    {(formik.values?.declarationType === 5 ||
                      formik.values?.declarationType === 2 ||
                      formik.values?.declarationType === 3) && (
                      <Grid container spacing={2} className="sub-section-3">
                        <Grid
                          item
                          xs={
                            formik.values?.declarationType === 2 ||
                            formik.values?.declarationType === 3
                              ? 12
                              : 6
                          }
                        >
                          <InputField
                            sx={{ pointerEvents: "none" }}
                            fullWidth
                            variant="standard"
                            placeholder="Martina Müller"
                            label={
                              formik.values?.declarationType === 2 ||
                              formik.values?.declarationType === 3
                                ? t("desc")
                                : t("soi-heading-2")
                            }
                            name="name"
                            type="text"
                            value={formik.values.declaration_name}
                          />
                        </Grid>
                        {formik.values?.declarationType === 5 && (
                          <>
                            {" "}
                            <Grid item xs={6}>
                              <InputField
                                sx={{ pointerEvents: "none" }}
                                fullWidth
                                placeholder="01774251951"
                                variant="standard"
                                label={t("input-4")}
                                name="phone"
                                type="string"
                                InputLabelProps={{ shrink: true }}
                                value={formik.values.declaration_phone}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <InputField
                                sx={{ pointerEvents: "none" }}
                                fullWidth
                                placeholder="Turmbergstraße 21"
                                variant="standard"
                                label={t("input-6")}
                                name="street"
                                type="string"
                                value={formik.values.declaration_street}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <InputField
                                sx={{ pointerEvents: "none" }}
                                fullWidth
                                placeholder="76227 Karlsruhe"
                                variant="standard"
                                label={t("input-9")}
                                name="postCode"
                                type="text"
                                value={formik.values.declaration_postCode}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <InputField
                                sx={{ pointerEvents: "none" }}
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                                variant="standard"
                                label={t("date")}
                                name="date"
                                type="date"
                                value={formik.values.declaration_date}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <InputField
                                sx={{ pointerEvents: "none" }}
                                fullWidth
                                variant="standard"
                                label={t("doc-tab-3")}
                                name="signature"
                                type="signature"
                                value=""
                              />
                            </Grid>
                          </>
                        )}
                      </Grid>
                    )}
                    <Divider className="divider-1" />
                    <Typography variant="h4" className="typography-2">
                      {t("od-card-text")}
                    </Typography>
                    <Grid
                      container
                      className="sub-section-4"
                      marginBottom="120px"
                    >
                      <Grid item xs={6}>
                        <InputField
                          sx={{ pointerEvents: "none" }}
                          fullWidth
                          variant="standard"
                          label={t("input-5")}
                          name="firstName"
                          type="text"
                          value={formik.values.name}
                          InputLabelProps={{ shrink: true }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <InputField
                          sx={{ pointerEvents: "none" }}
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                          variant="standard"
                          label={t("input-2")}
                          name="date"
                          type="date"
                          value={formik.values.dateOfBirth}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <InputField
                          sx={{ pointerEvents: "none" }}
                          fullWidth
                          variant="standard"
                          placeholder="Raithstr. 34 in 75417 Mühlacker"
                          label={t("input-12")}
                          name="address"
                          type="text"
                          value={`${
                            formik.values?.street ? formik.values.street : ""
                          } ${
                            formik.values?.houseNumber
                              ? formik.values.houseNumber + ","
                              : ""
                          } ${
                            formik.values?.postCode
                              ? formik.values.postCode + ","
                              : ""
                          } ${formik.values?.city ? formik.values.city : ""}
                      `}
                          InputLabelProps={{ shrink: true }}
                        />
                      </Grid>
                    </Grid>
                  </Form>
                )}
              </Formik>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default OrganDonationOverview;
